import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {UploadStatusHandler} from "../utils/UploadStatusHandler";
import {newsletterInteractionEmailEdit_template} from "../components/templates/newsletterInteractionEmailEdit_template";

declare var ko: any;
declare var page: any;
declare var CKEDITOR: any;

let contentEditor;
let signatureEditor;
let imageDescriptionEditor;
let imageCaptionEditor;
let bulkImageCaptionEditor;
let bulkImageDescriptionEditor;

export class newsletter_interaction_email_edit extends vnModule_knockoutJS {

    protected newsletterInteractionEmailEditTemplate: newsletterInteractionEmailEdit_template;
    protected XHRHdl: XMLHttpRequestHandler;
    protected imageXHRHdl: XMLHttpRequestHandler;
    protected tagXHRHdl: XMLHttpRequestHandler;
    protected tagSearchXHRHdl: XMLHttpRequestHandler;
    private imageMode: string;
    private XHRHdlCaller: string;
    private contentImageXHRHdl: any;
    protected progressBar: HTMLProgressElement;
    protected uploadProgress: any;
    public uploadStatus: UploadStatusHandler = new UploadStatusHandler();

    buildContent(): Array<Element> {

        this.newsletterInteractionEmailEditTemplate = new newsletterInteractionEmailEdit_template("newsletterInteractionEmailEdit_template", this.viewModel, this);
        return [this.newsletterInteractionEmailEditTemplate.build()];
    }

    protected getModuleName(): string {

        return "newsletterInteractionEmailEdit_template";
    }

    protected getImagePickerHelper() {
        return this.newsletterInteractionEmailEditTemplate.imagePickerHelper;
    }

    public fillPage(): void {

        this.getNewsletterReferences()
        this.initializeCkEditors()
    }

    protected showImagePicker(mode, target) {

        if (typeof target.name !== 'undefined' && target.name !== null){
            target = target.name // @TODO revisit
        }

        this.newsletterInteractionEmailEditTemplate.showImagePicker(mode, target);

    }

    protected showTagPicker(editor) {

        this.newsletterInteractionEmailEditTemplate.tagPicker.resetPagination();
        this.getTagData();

        this.newsletterInteractionEmailEditTemplate.showTagPicker("in-content", editor.name);
    }

    protected initializeCkEditors() {

        for(let name in CKEDITOR.instances)
        {
            CKEDITOR.instances[name].destroy(true);
        }

        if (!CKEDITOR.stylesSet.registered.my_styles) {
            CKEDITOR.stylesSet.add('my_styles', [
                // Block-level styles.
                {name: 'Heading 1', element: 'h1'},
                {name: 'Heading 2', element: 'h2'},
                {name: 'Heading 3', element: 'h3'},
                {name: 'Preformatted', element: 'pre'},
                // Inline styles.
                {name: 'Related: One link', element: 'span', attributes: {'class': 'related-single'}},
                {name: 'Next - One link', element: 'span', attributes: {'class': 'next-single'}},
                {name: 'Affiliate - One link', element: 'span', attributes: {'class': 'affiliate-single'}},
                {name: 'Spoiler Alert', element: 'span', attributes: {'class': 'article-alert'}},
                {name: 'Tip', element: 'div', attributes: {'class': 'emaki-custom tip'}},
                {name: 'Warning', element: 'div', attributes: {'class': 'emaki-custom warning'}},
                {name: 'Note', element: 'div', attributes: {'class': 'emaki-custom note'}},
                {name: 'Expandable', element: 'div', attributes: {'class': 'emaki-custom expandable'}},
                {name: 'Pullquote', element: 'div', attributes: {'class': 'emaki-custom pullquote'}},
                {name: 'Promoted', element: 'div', attributes: {'class': 'emaki-custom promoted'}},

            ]);
        }
        //                {name: '', element: 'span', attributes: {'data-field': 'rating'}},


        CKEDITOR.on('dialogDefinition', function (ev) {
            var dialogName = ev.data.name;
            var dialogDefinition = ev.data.definition;

            //Remove background color and border color in dialog cells properties
            if(dialogName == "cellProperties"){
                // "bgColor"
                // "borderColor"
                const cellProps = dialogDefinition.getContents('info');
                cellProps.remove("borderColor")
                cellProps.remove("bgColor")
            }

            //remove features from table dialog
            if (dialogName == 'table') {

                // Get the advanced tab reference
                var infoTab2 = dialogDefinition.getContents('advanced');

                //Set the default
                // Remove the 'Advanced' tab completely
                dialogDefinition.removeContents('advanced');

                // Get the properties tab reference
                var infoTab = dialogDefinition.getContents('info');

                // Remove unnecessary bits from this tab
                /// infoTab.remove('txtBorder');
                infoTab.remove('cmbAlign');
                infoTab.remove('txtWidth');
                infoTab.remove('txtHeight');
                // infoTab.remove('txtCellSpace');
                //infoTab.remove('txtCellPad');
                infoTab.remove('txtCaption');
                infoTab.remove('txtSummary');
            }


            if (dialogName == 'link') {

                /* Getting the contents of the Target tab */

                var targetTab = dialogDefinition.getContents('target');
                var informationTab = dialogDefinition.getContents('info');
                var advancedTab = dialogDefinition.getContents('advanced');

                //remove the browse server button
                informationTab.remove('browse')

                //moving the target dropdown to the main tab
                var targetField = targetTab.get('linkTargetType');

                targetTab.remove('linkTargetType');
                informationTab.add(targetField);

            }
        });

        let allEditors = [];

        this.initCkEditor('contentText');
        contentEditor = CKEDITOR.instances.contentText;
        allEditors.push(contentEditor);

        this.initCkEditor('signatureText');
        signatureEditor = CKEDITOR.instances.signatureText;
        allEditors.push(signatureEditor);

        // Image Description Editor
        this.initCkEditor('image_description');
        imageDescriptionEditor = CKEDITOR.instances.image_description;
        allEditors.push(imageDescriptionEditor);

        // Image Caption Editor
        this.initCkEditor('image_caption');
        imageCaptionEditor = CKEDITOR.instances.image_caption;
        allEditors.push(imageCaptionEditor);

        let that = this

        this.initCkEditor('bulk_image_description');
        bulkImageDescriptionEditor = CKEDITOR.instances.bulk_image_description;
        bulkImageDescriptionEditor.on('change', function () {
            that.newsletterInteractionEmailEditTemplate.imagePicker.imagesBulkEdit.getTemplateViewModel().description(this.getData())
        })
        allEditors.push(bulkImageDescriptionEditor);

        this.initCkEditor('bulk_image_caption');

        bulkImageCaptionEditor = CKEDITOR.instances.bulk_image_caption;
        bulkImageCaptionEditor.on('change', function () {
            that.newsletterInteractionEmailEditTemplate.imagePicker.imagesBulkEdit.getTemplateViewModel().caption(this.getData())
        })
        allEditors.push(bulkImageCaptionEditor);

        // Adds comments to specified editors
        this.addLinkToolCommand(allEditors);
        this.addImagePickerCommand(allEditors);
        this.addUpdateBlockCommand([ contentEditor, signatureEditor, imageDescriptionEditor, imageCaptionEditor ]);
        this.addOnClickContentHandler( [contentEditor, signatureEditor] )
        this.addTagPickerCommand([ contentEditor, signatureEditor]);
        this.addInsertArticleCommand(allEditors);

        this.newsletterInteractionEmailEditTemplate.initTagPickerCkEditors();
    }

    protected initCkEditor(idElement) {

        CKEDITOR.replace(idElement, {
            height: '500px',
            toolbar: 'MA',
            fillEmptyBlocks: false,
            extraAllowedContent: 'img(*){*}[*];div(*){*}[*];pre(*){*}[*];code(*){*}[*];a[rel];a[target];a(*)',
            disallowedContent: 'p',
            removePlugins: 'elementspath,contextmenu,liststyle,tabletools,tableselection,image,forms',
            stylesSet: 'my_styles',
            format_tags: "p;h1;h2;h3",
            format_p: {
                element: 'p'
            }
        });

        //'JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock'
        //'Outdent','Indent'

        CKEDITOR.config.toolbar_MA = [['Source', '-', 'Cut', 'Copy', 'Paste', '-', 'Undo', 'Redo', 'RemoveFormat', '-', 'Link', 'Unlink', '-', 'Table', 'HorizontalRule', 'SpecialChar', 'ImgBtn', 'Styles', 'InsertArticleBtn', 'TagBtn'], ['Bold', 'Italic', 'Strike', 'NumberedList', 'BulletedList', '-', 'Blockquote', 'LinkBtn', 'Maximize']];

        CKEDITOR.config.enterMode = CKEDITOR.ENTER_BR;

        CKEDITOR.config.contentsCss = [CKEDITOR.getUrl('contents.css'), '/css/cke_style.css?v=2.5'];

        //CKEDITOR.config.disallowedContent = 'p';

        CKEDITOR.config.skin = "n1theme";
        //CKEDITOR.config.skin ="kama";
        //CKEDITOR.config.skin ="moono";
        //CKEDITOR.config.skin ="moono-lisa";

        CKEDITOR.config.extraPlugins = "wordcount,notification";
        //CKEDITOR.config.extraPlugins ="justify";
        //CKEDITOR.config.extraPlugins ="colorbutton";

        CKEDITOR.config.forcePasteAsPlainText = true;
        contentEditor = CKEDITOR.instances.contentText;

        CKEDITOR.config.wordcount = {
            // Whether or not you want to show the Paragraphs Count
            showParagraphs: false,

            // Whether or not you want to show the Word Count
            showWordCount: true,

            // Whether or not you want to show the Char Count
            showCharCount: true
        }
        CKEDITOR.config.allowedContent = true;


    }

    protected addLinkToolCommand(editors) {

        editors.forEach(function (editor) {

            function showLinkTool(obj) {

                return {
                    exec: function (editor) {
                        obj.showLinkTool();
                    }
                };

            }

            editor.addCommand("linkToolCommand", showLinkTool(this));

            editor.ui.addButton('LinkBtn', { // add new button and bind our command
                label: "Link Tool",
                command: 'linkToolCommand',
                toolbar: 'insert',
            });
        })
    }

    protected showLinkTool() {

        let url = "https://datastudio.google.com/u/0/reporting/1JtF204Vz8MIa9DhToLzu4Ou2bIqTSuVt/page/4uYeB";
        //launch the link tool in new tab
        var element = document.createElement('a');
        element.setAttribute('href', url);
        element.setAttribute('target', '_blank');
        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    }

    protected addUpdateBlockCommand(editors) {
        let _myThis = this;

        editors.forEach(function (editor) {

            function addUpdateBlock(obj) {

                return {
                    exec: function (editor) {
                        _myThis.addUpdateBlock(editor);
                    }
                };
            }

            editor.addCommand("updateBlockCommand", addUpdateBlock(this));

            editor.ui.addButton('UpdateBtn', { // add new button and bind our command
                label: "Update",
                command: 'updateBlockCommand',
                toolbar: 'insert',

            });
        });
    }

    protected addUpdateBlock(editor) {
        let d = new Date();
        let dformat = [d.getFullYear(), ('0' + (d.getMonth() + 1)).slice(-2), ('0' + d.getDate()).slice(-2)].join('/') + ' ' + [('0' + d.getHours()).slice(-2), ('0' + d.getMinutes()).slice(-2)].join(':') + " EST";
        let authorName = this.getVnAppZone().app.loggedUser.user.valnet_user.fullName;
        let tag = '<div class="emaki-custom update"><h3>UPDATE: ' + dformat + ' BY ' + authorName.toUpperCase() + '</h3><strong><em>Title Here..</em></strong><br><br>Text Here..</div>'

        var tagElement = CKEDITOR.dom.element.createFromHtml(tag, editor.document);
        editor.insertElement(tagElement);
    }

    protected addTagPickerCommand(editors) {

        let _myThis = this;
        editors.forEach(function (editor) {

            function showMyDialog(obj) {

                return {
                    exec: function (editor) {
                        _myThis.showTagPicker(editor);
                    }
                };
            }

            editor.addCommand("tagPickerCommand", showMyDialog(this));

            editor.ui.addButton('TagBtn', { // add new button and bind our command
                label: "Insert Tags",
                command: 'tagPickerCommand',
                toolbar: 'insert',
                icon: '/assets/images/tag.png'
            });
        })
    }

    protected addInsertArticleCommand(editors){

        let _myThis = this;

        editors.forEach(function (editor) {
            function showInsertArticledDialog(obj) {
                return {
                    exec: function (editor) {
                        _myThis.showInsertArticlePopUp(editor);
                    }
                };
            }

            editor.addCommand("insertArticleCommand", showInsertArticledDialog(this));

            editor.ui.addButton('InsertArticleBtn', { // add new button and bind our command
                label: "Insert Article",
                command: 'insertArticleCommand',
                toolbar: 'insert',
                icon: '/assets/images/article.png'
            });
        });
    }

    protected addImagePickerCommand(editors) {
        let _myThis = this;

        editors.forEach(function (editor) {

            function showMyDialog(obj) {

                return {
                    exec: function (editor) {
                        _myThis.showImagePicker("single-select", editor);
                    }
                };
            }

            editor.addCommand("imagePickerCommand", showMyDialog(this));

            editor.ui.addButton('ImgBtn', { // add new button and bind our command
                label: "Insert Images",
                command: 'imagePickerCommand',
                toolbar: 'insert',
                icon: '/node_modules/ckeditor4/plugins/image2/icons/image.png'
            });
        })
    }

    public cancelForm() {

        this.onClickCancelEdit();
    }

    public onClickCancelEdit() {

        let brandId = this.getVnAppZone().app.params.idBrand
        page.redirect("/brand/" + brandId + "/newsletter/interaction-emails/")
    }

    protected save(type) {

        this.loadingIn(this.newsletterInteractionEmailEditTemplate.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url: string = '/api/brand/' + idBrand + "/newsletter/interaction-emails/save/";
        let formReq_params: Array<Array<string>> = [];

        this.newsletterInteractionEmailEditTemplate.getTemplateViewModel().content(contentEditor.getData());
        this.newsletterInteractionEmailEditTemplate.getTemplateViewModel().signature(signatureEditor.getData());

        let subViewModel = JSON.parse(ko.toJSON(this.newsletterInteractionEmailEditTemplate.getViewModelForRequest()));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onSaveReturn
        XHRHdl.execute();
    }

    protected onSaveReturn (req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {

                if (req.request.status === 200) {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Newsletter Interaction Email saved !");
                    obj.redirectToInteractionEmailList();
                }

            });
            obj.loadingOut(obj.newsletterInteractionEmailEditTemplate.builtTemplate);

        }
    }

    protected redirectToInteractionEmailList(){

        page.redirect('/brand/' + this.getVnAppZone().app.params.idBrand + "/newsletter/interaction-emails/");
    }

    protected getNewsletterReferences() {

        // LOADING : starts
        this.loadingIn(this.newsletterInteractionEmailEditTemplate.builtTemplate);

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/interaction-emails/references';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onNewsletterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onNewsletterRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                obj.loadingOut(obj.newsletterInteractionEmailEditTemplate.builtTemplate);

                //check if user has article write permissions
                let responseParsed = JSON.parse(req.request.response);

                obj.newsletterInteractionEmailEditTemplate.tagPicker.setTagViewBadgeOptions(responseParsed.badges);
                obj.newsletterInteractionEmailEditTemplate.setPermissions(responseParsed.permissions)
                obj.newsletterInteractionEmailEditTemplate.setTypes(responseParsed.types)
                obj.newsletterInteractionEmailEditTemplate.setTemplates(responseParsed.templates)

                obj.getNewsletterInteractionEmailDataForEdit();
            })
        }
    }

    protected getNewsletterInteractionEmailDataForEdit() {

        this.loadingIn(this.newsletterInteractionEmailEditTemplate.builtTemplate);

        let url : string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/interaction-emails/get/' + this.getVnAppZone().app.params.id + '/';
        let request_parameters : Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetNewsletterInteractionEmailDataForEdit;
        this.XHRHdl.execute();

    }

    protected onGetNewsletterInteractionEmailDataForEdit(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                let interactionEmail = responseParsed.interactionEmail
                obj.setNewsletterInteractionEmailData(interactionEmail);
            });
            obj.loadingOut(obj.newsletterInteractionEmailEditTemplate.builtTemplate);
        }
    }

    protected setNewsletterInteractionEmailData(interactionEmail) {

        this.newsletterInteractionEmailEditTemplate.setId(interactionEmail.id);
        this.newsletterInteractionEmailEditTemplate.setSubject(interactionEmail.subject);
        this.newsletterInteractionEmailEditTemplate.setPreviewText(interactionEmail.previewText);

        let type = interactionEmail.type;
        if(type){
            this.newsletterInteractionEmailEditTemplate.typeSelector.setSelectedOption(type.id);
        }

        let template = interactionEmail.template;
        if(template){
            this.newsletterInteractionEmailEditTemplate.templateSelector.setSelectedOption(template.id);
        }

        let content = interactionEmail.content;
        contentEditor.setData(content, function () {
            this.resetUndo();
        });

        let signature = interactionEmail.signature;
        signatureEditor.setData(signature, function () {
            this.resetUndo();
        });
    }

    //image picker functions
    protected getImageData(keyword = null) {

        if (this.imageXHRHdl) {
            this.imageXHRHdl.cancelAndReset();
        }

        this.newsletterInteractionEmailEditTemplate.imagePicker.showLoading();

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + '/images/get/';
        let formReq_params: Array<Array<string>> = [];

        //let subViewModel = JSON.parse(ko.toJSON(this.viewModel));
        let viewModel = this.newsletterInteractionEmailEditTemplate.imagePicker.getViewModelForRequest();
        /*if(keyword != null){
            viewModel.filters.keywords(keyword);
        }*/
        formReq_params.push(["data", ko.toJSON(viewModel)]);

        this.imageXHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.imageXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.imageXHRHdl.onReadyStateFunction = this.onGetImageDataReturn;
        this.imageXHRHdl.execute();
    }

    protected onGetImageDataReturn(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.updateImagePickerForm(responseParsed);
                obj.newsletterInteractionEmailEditTemplate.imagePicker.hideLoading();
                if(obj.newsletterInteractionEmailEditTemplate.imagePicker.getSelectedTab() == 'images' || obj.isSaveImage) {
                    obj.isSaveImage = false;
                }
            })
        }
    }

    protected updateImagePickerForm(responseParsed) {

        let selectedImages = this.newsletterInteractionEmailEditTemplate.imagePicker.getSelectedImages();

        if( responseParsed.paginatedImages && responseParsed.paginatedImages.data ){
            for(let image of responseParsed.paginatedImages.data){
                image.selected = false;
                let imageSelected = selectedImages.find(i => i.id == image.id);
                if (imageSelected) {
                    image.selected = true;
                }
                image.fileSize = this.bytesToSize(image.fileSize);
            }
            this.newsletterInteractionEmailEditTemplate.imagePicker.setImagesPagination(responseParsed.paginatedImages);
            this.newsletterInteractionEmailEditTemplate.imagePicker.setImageResults(responseParsed.paginatedImages.data);
        }

        if (responseParsed.imagesInContent) {
            for (let image of responseParsed.imagesInContent) {
                image.selected = false;
                let imageSelected = selectedImages.find(i => i.id == image.id);
                if (imageSelected) {
                    image.selected = true;
                }
                image.fileSize = this.bytesToSize(image.fileSize);
            }
            this.newsletterInteractionEmailEditTemplate.imagePicker.setImagesInContent(responseParsed.imagesInContent);
        }

        let selectedGallery = this.newsletterInteractionEmailEditTemplate.imagePicker.getSelectedGallery();

        if( responseParsed.paginatedGalleries && responseParsed.paginatedGalleries.data){
            for(let gallery of responseParsed.paginatedGalleries.data){
                gallery.selected = false;
                if (selectedGallery != null) {
                    if (selectedGallery.id == gallery.id) {
                        gallery.selected = true;
                    }
                }
            }
            this.newsletterInteractionEmailEditTemplate.imagePicker.setGalleryPagination(responseParsed.paginatedGalleries);
            this.newsletterInteractionEmailEditTemplate.imagePicker.setGalleryResults(responseParsed.paginatedGalleries.data);
        }

        if (responseParsed.ratios) {
            this.newsletterInteractionEmailEditTemplate.imagePicker.setRatios(responseParsed.ratios);
        }

        if (responseParsed.orientations) {
            this.newsletterInteractionEmailEditTemplate.imagePicker.setOrientations(responseParsed.orientations);
        }

        if (responseParsed.uploadSources) {
            this.newsletterInteractionEmailEditTemplate.imagePicker.setUploadSources(responseParsed.uploadSources, responseParsed.selectedUploadSource);
        }

        if (responseParsed.idBrand) {
            this.newsletterInteractionEmailEditTemplate.imagePicker.setIdBrand(responseParsed.idBrand);
        }

    }

    protected bytesToSize(bytes){

        var sizes = ['KB', 'MB', 'GB', 'TB'];
        if (bytes == 0) return 'n/a';
        var i = parseInt(String(Math.floor(Math.log(bytes) / Math.log(1024))));
        if (i == 0) return bytes + ' ' + sizes[i];
        return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
    };

    protected saveImages(images, insert, param, insertType='image') {

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + '/images/save/';
        let formReq_params: Array<Array<string>> = [];

        formReq_params.push(["data", ko.toJSON(images)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    let response = JSON.parse(req.request.response);

                    let target = obj.newsletterInteractionEmailEditTemplate.getImagePickerTarget();

                    obj.newsletterInteractionEmailEditTemplate.setImagePickerTarget(null);

                    obj.newsletterInteractionEmailEditTemplate.imagePicker.onImageSaveReturn(response.images, insert, param, insertType);

                    obj.getImageData();
                })

            }
        });
        XHRHdl.execute();
    }

    protected reset(){

        this.newsletterInteractionEmailEditTemplate.imagePicker.hidePickerUploadError();
    }

    protected insertImage(image, target, extra_option) {
        if (target.element){

            let element = target.element;
            element.parentElement.removeChild(element);
            target = target.editor;
        }

        if (target == "tagImageOverride" || target == "tagImageOverrideEdit" ) {
            this.newsletterInteractionEmailEditTemplate.tagPicker.setTagImageOverride(image);
        }else if (target == "tagImageEdit") {
            this.newsletterInteractionEmailEditTemplate.tagPicker.setTagImage(image);
        }else if (target == "tagIconImageEdit") {
            this.newsletterInteractionEmailEditTemplate.tagPicker.setTagIconImage(image); // @TODO maybe don't do this
        }else if (target == "tagImageBadge") {
            this.newsletterInteractionEmailEditTemplate.tagPicker.setTagImageBadge(image);
        }

        let imgTag = this.buildImageTag(image, false, extra_option);
        let editor = this.getEditor(target);

        if (typeof editor !== 'undefined' && editor !== null && typeof editor.insertHtml === 'function') {
            this.insertTag(imgTag, editor);
        }


    }

    protected buildImageTag(image, addCaption, extra_option): string {

        let imgTag = '<img ';

        imgTag += 'src="' + image.url + '" ';
        if (image.altText != null) {
            imgTag += 'alt="' + image.altText + '" ';
        } else {
            imgTag += 'alt="" ';
        }
        imgTag += ' width=' + image.width + ' height=' + image.height + ' />';

        //add caption
        if (addCaption && image.caption != null && image.caption.trim() != "") {
            imgTag = '[caption]' + imgTag + ' ' + image.caption + '[/caption]';
        }

        return imgTag;
    }

    protected insertTag(tag, editor) {

        editor.insertHtml(tag);
    }

    protected addOnClickContentHandler(editors) {

        let _myThis = this;
        editors.forEach(function (editor) {

            editor.on("pluginsLoaded", function (event) {
                editor.on('contentDom', function () {
                    var editable = editor.editable();
                    editable.attachListener(editable, 'click', function (evt) {
                        let target = evt.data.getTarget();
                        let el = target.$;
                        _myThis.onClickCkEditorElement(el, editor);
                    }, null, null, 10);
                });
            });
        })
    }

    protected onClickCkEditorElement(element, editor){

        let editorName = editor.name;
        //handle tag
        let foundTag = false;
        let foundGroup = false;
        let clone = element;

        let tagDisplayCard = this.isTagDisplayCard(element);

        if (tagDisplayCard.isSingleTag) {
            foundTag = true;
            element = tagDisplayCard.element;
        }

        if (tagDisplayCard.isGroupTag) {
            element = tagDisplayCard.element;
            foundGroup = true;
            foundTag = false;
        }

        if (this.newsletterInteractionEmailEditTemplate.isSectionForTagPicker(editorName)) {

            if (!foundGroup && !foundTag) {

                foundGroup = true;
            }
        }

        if(foundGroup) {
            this.editTagGroupElement(element, editorName);
            return;
        }

        if(foundTag) {
            this.editTagElement(element, editorName);
            return;
        }

        //handle image
        if (element.nodeName == "IMG"){
            let imgSrc = element.getAttribute("src");
            this.newsletterInteractionEmailEditTemplate.setImagePickerTarget(imgSrc);

            let target = {"element":element,"editor":editorName};

            this.newsletterInteractionEmailEditTemplate.showImagePicker("content-select", target);
            this.setImageMode("content-select")

            this.getImage(imgSrc);
        }
    }

    public isTagDisplayCard(element) {

        let originalElement = element;
        let elementInfo = {isSingleTag: false, isGroupTag: false, element: originalElement};

        while(element) {
            if (element.nodeName == "DIV" && element.classList.contains('emaki-displayCard') && element.classList.contains('tag')) {

                elementInfo.isSingleTag = true;
                elementInfo.element = element;
                if (element.parentNode.nodeName == "DIV" && element.parentNode.classList.contains('emaki-displayCard-group')) {

                    elementInfo.isSingleTag = false;
                    elementInfo.isGroupTag = true;
                    elementInfo.element = element.parentNode;
                    break;
                }
            }

            element = element.parentNode;
        }

        return elementInfo;
    }

    protected getImage(imgSrc){

        if (this.contentImageXHRHdl) {
            this.contentImageXHRHdl.cancelAndReset();
        }

        let idBrand = this.getVnAppZone().app.params.idBrand;

        let formReq_url: string = '/api/brand/' + idBrand + '/images/get-content-image/';
        let formReq_params: Array<Array<string>> = [];
        formReq_params.push(["imgSrc", imgSrc]);

        this.contentImageXHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.contentImageXHRHdl.onReadyStateFunction = this.onImageRequestReturn;
        this.contentImageXHRHdl.execute();
    }

    protected onImageRequestReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {

                //check if user has article write permissions
                let responseParsed = JSON.parse(req.request.response);

                let image = responseParsed.image.data[0];

                obj.newsletterInteractionEmailEditTemplate.imagePicker.editImage(image, obj.getImageMode());

                obj.newsletterInteractionEmailEditTemplate.imagePicker.hideLoading();
            });
        }
    }

    // protected editImage(image, mode = ""){

    //     this.newsletterInteractionEmailEditTemplate.imagePicker.editImage(image, mode);
    // }

    public getImageDescription(description) {

        return imageDescriptionEditor.getData();
    }

    public setImageDescription(description) {

        imageDescriptionEditor.setData(description, function () {
            this.resetUndo();
        });
    }

    public getImageCaption(description) {

        return imageCaptionEditor.getData();
    }

    public setImageCaption(caption) {

        imageCaptionEditor.setData(caption, function () {
            this.resetUndo();
        });
    }

    private getImageMode() : string{

        return this.imageMode
    }

    private setImageMode(mode : string) : void {

        this.imageMode = mode
    }

    protected handleFiles(files) {

        this.uploadImages(files);

    }

    protected uploadImages(files) {

        console.log('trial  - ' + this.uploadStatus.currentTrial);

        let parent = this;
        let idBrand = this.getVnAppZone().app.params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + '/images/upload/';

        var formData = new FormData();

        this.initializeProgress(files.length);

        if (files.length > 1) {

            this.newsletterInteractionEmailEditTemplate.imagePicker.showLoading();
        }

        this.newsletterInteractionEmailEditTemplate.imagePicker.clearFilters();

        // upload status vars.
        this.uploadStatus.nextTrial();

        for (let i = 0; i < files.length; i++) {

            formData.append("file_" + i, files[i]);

        }
        formData.append("idBrand", idBrand);

        let request = [];
        var xhttp = new XMLHttpRequest();
        request["request"] = xhttp;

        // Set POST method and ajax file path
        xhttp.open("POST", formReq_url, true);

        let onReadyStateFunction = (function (req, obj) {

            return function () {

                if (req.request.readyState == 4) {

                    if (req.request.status == 200) {

                        // reset the upload status when successful operation is complete.
                        obj.uploadStatus.reset();
                        let fileElement: any = document.getElementById("fileElem");
                        fileElement.value = '';
                        let response = JSON.parse(req.request.response);

                        obj.updateProgress(response.images.length, 100) // <- Add this

                        if (response.images.length == 1 && response.errors.length == 0) {

                            obj.newsletterInteractionEmailEditTemplate.imagePicker.editImage(response.images[0]);
                            obj.newsletterInteractionEmailEditTemplate.imagePicker.hideLoading();
                        }

                        if ((response.images.length == 1 && response.errors.length == 1) || response.images.length > 1) {

                            obj.newsletterInteractionEmailEditTemplate.imagePicker.hideImageAdd();
                            obj.newsletterInteractionEmailEditTemplate.imagePicker.handleBulkImages(response.images);
                            obj.newsletterInteractionEmailEditTemplate.imagePicker.hideLoading();

                            if (response.errors.length == 1) {
                                obj.newsletterInteractionEmailEditTemplate.imagePicker.imagesBulkEdit.validationsList.setMessages(response.errors);
                            }
                        }

                        obj.resetProgress();
                        obj.validationTemplate.clearMessages();

                    } else if (req.request.status == 400) {

                        let responseParsed = JSON.parse(req.request.response)
                        obj.newsletterInteractionEmailEditTemplate.imagePicker.imageAdd.validationsList.setMessages(responseParsed.validations);
                        obj.newsletterInteractionEmailEditTemplate.imagePicker.hideLoading();
                        window.scrollTo(0, 0);

                    } else {
                        obj.uploadStatus.isInProgress = false;
                        obj.newsletterInteractionEmailEditTemplate.imagePicker.showUploadError();
                    }
                }

            }
        });

        // call on request changes state
        xhttp.onreadystatechange = onReadyStateFunction(request, this);

        let firstTime = new Date().getTime();
        xhttp.upload.addEventListener("progress", function (e) {

            parent.uploadStatus.progress = e.loaded;
            let progressTime = new Date().getTime();
            let diff =  progressTime - firstTime;
            firstTime = progressTime;
            console.log('Upload Image progress: ', e.loaded, e.total, parent.uploadStatus.progress, diff);
        });

        xhttp.upload.addEventListener('loadend', (e) => {

            if (!parent.uploadStatus.isInProgress && parent.uploadStatus.trialsReached()) {
                xhttp.abort();
                parent.newsletterInteractionEmailEditTemplate.imagePicker.showPickerUploadError();
                parent.newsletterInteractionEmailEditTemplate.imagePicker.hideLoading();
            }
            console.log('Upload Image Loadend: ', parent.uploadStatus.progress, e.loaded, e.total);
        });

        xhttp.upload.addEventListener('loadstart', (e) => {

            console.log('timeout started');
            setTimeout(() => {

                // check after one second if the progress is blocked then trigger another try.
                if (!parent.uploadStatus.isInProgress && !parent.uploadStatus.trialsReached()) {
                    xhttp.abort();
                    parent.uploadImages(files);
                }
            }, 1000);

        });

        // Send request with data
        xhttp.send(formData);
    }

    protected initializeProgress(numFiles) {

        this.progressBar = <HTMLProgressElement>document.getElementById('progress-bar');
        this.progressBar.value = 0
        this.uploadProgress = [];

        for (let i = numFiles; i > 0; i--) {
            this.uploadProgress.push(0)
        }
    }

    protected resetProgress() {

        this.progressBar = <HTMLProgressElement>document.getElementById('progress-bar');
        this.progressBar.value = 0
    }

    protected updateProgress(fileNumber, percent): void {

        this.progressBar.value = percent;
    }

    //tag picker functions
    protected getTagData() {

        if (this.tagSearchXHRHdl) {
            this.tagSearchXHRHdl.cancelAndReset();
        }

        this.newsletterInteractionEmailEditTemplate.tagPicker.showLoading();

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + '/tags/get/';
        let formReq_params: Array<Array<string>> = [];

        //let subViewModel = JSON.parse(ko.toJSON(this.viewModel));
        let viewModel = this.newsletterInteractionEmailEditTemplate.tagPicker.getViewModelForRequest();
        /*if(keyword != null){
            viewModel.filters.keywords(keyword);
        }*/
        formReq_params.push(["data", ko.toJSON(viewModel)]);

        this.tagSearchXHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.tagSearchXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.tagSearchXHRHdl.onReadyStateFunction = this.onGetTagDataReturn;
        this.tagSearchXHRHdl.execute();
    }

    protected onGetTagDataReturn(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.updateTagPickerForm(responseParsed);
                obj.newsletterInteractionEmailEditTemplate.tagPicker.hideLoading();
            })
        }
    }

    protected editTagElement(element, editor){

        let idTag = element.getAttribute("data-id");
        this.getTag(idTag);

        this.newsletterInteractionEmailEditTemplate.editTagElement(element, editor);
    }

    public getTag(tag, select = false){

        this.getTags([tag], select);
    }

    protected getTags(idTags, select = false) {

        if (this.tagXHRHdl) {
            this.tagXHRHdl.cancelAndReset();
        }

        if(idTags.length > 1){

            this.XHRHdlCaller = "tag_picker_group";
            this.newsletterInteractionEmailEditTemplate.tagPicker.showLoading();
        }else{

            if(select){

                this.XHRHdlCaller = "tag_picker_select";
                this.newsletterInteractionEmailEditTemplate.tagPicker.showLoading();
            }else{

                this.XHRHdlCaller = "tag_picker_view";
                this.newsletterInteractionEmailEditTemplate.tagPicker.showViewLoading();
            }

        }

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url = '/api/brand/' + idBrand + "/tag-picker/tags/get/";

        let usrReq_params: Array<Array<string>> = [];

        //let vm:any = this.newsletterInteractionEmailEditTemplate.getViewModelForRequest();
        //vm.lockItem = true;

        usrReq_params.push(["data", ko.toJSON({ idTags: idTags})]);

        this.tagXHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.tagXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.tagXHRHdl.onReadyStateFunction = this.onGetTagRequestReturn;
        this.tagXHRHdl.execute();
    }

    protected onGetTagRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                if (responseParsed.tags && responseParsed.tags.length > 0) {

                    if(obj.XHRHdlCaller == "tag_picker_group"){
                        let tagsResponse = responseParsed.tags;
                        let tags = [];
                        for(let response of tagsResponse){
                            let tag = response.tag;
                            tag.specsValues = response.specsValues;
                            tag.specDefaults = response.specDefaults;
                            tag.communityRating = response.communityRating? response.communityRating : { average: null, count: 0 };
                            tag.includeCommunityRating = response.includeCommunityRating? response.includeCommunityRating : false;
                            tags.push(tag);
                        }
                        obj.newsletterInteractionEmailEditTemplate.tagPicker.selectTags(tags);
                    }else{
                        let tag = responseParsed.tags[0].tag;
                        tag.specsValues =  responseParsed.tags[0].specsValues;
                        tag.specDefaults =  responseParsed.tags[0].specDefaults;
                        tag.communityRating = responseParsed.tags[0].communityRating? responseParsed.tags[0].communityRating : { average: null, count: 0 };
                        tag.includeCommunityRating = responseParsed.tags[0].includeCommunityRating? responseParsed.tags[0].includeCommunityRating : false;
                        if(obj.XHRHdlCaller == "tag_picker_select"){
                            obj.newsletterInteractionEmailEditTemplate.tagPicker.selectTag({... tag, pros : [], cons : [] }, true);
                        }else if(obj.XHRHdlCaller == "tag_picker_view"){
                            obj.newsletterInteractionEmailEditTemplate.tagPicker.setTag({... tag, pros : [], cons : [] });
                        }
                    }



                }
                //obj.editForm.setPermissions(responseParsed.permissions);
            });

            obj.newsletterInteractionEmailEditTemplate.tagPicker.hideViewLoading();
            obj.newsletterInteractionEmailEditTemplate.tagPicker.hideLoading();
            if(obj.validationTemplate.getTemplateViewModel().isHidden() == 0) {
                obj.newsletterInteractionEmailEditTemplate.addTagPickerValidationClass();
            } else if(obj.validationTemplate.getTemplateViewModel().isHidden() == 1) {
                obj.newsletterInteractionEmailEditTemplate.removeTagPickerValidationClass();
            }
        }
    }

    protected editTagGroupElement(element, editor){

        let tagIds = [];
        for (let child of element.childNodes){
            if(child.nodeName == "DIV" && child.className == "emaki-displayCard tag"){

                let idTag = child.getAttribute("data-id");
                if(idTag != null){
                    tagIds.push(idTag);
                }
            }

        }

        if(tagIds.length == 1){
            this.getTags(tagIds);
            this.newsletterInteractionEmailEditTemplate.editTagElement(element, editor);
        }else if(tagIds.length > 1){
            this.getTags(tagIds);
            this.newsletterInteractionEmailEditTemplate.editTagGroup(element, editor);
        }

    }

    public setTagEditLock(tag){

        this.newsletterInteractionEmailEditTemplate.tagPicker.showViewLoading();
        this.XHRHdlCaller = "tag_picker_edit";
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url = '/api/brand/' + idBrand + "/tag-picker/tags/get/";

        let usrReq_params: Array<Array<string>> = [];

        usrReq_params.push(["data", ko.toJSON({ idTags: [tag.id] , lockItem : true })]);

        this.tagXHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.tagXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.tagXHRHdl.onReadyStateFunction = this.sendSimpleRequest;
        this.tagXHRHdl.execute();
    }

    public releaseBrandTagLock(idTag){

        this.XHRHdlCaller = "tag_picker_edit_cancel";
        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let usrReq_url = `/api/brand/${idBrand}/tags/release/${idTag}`;

        let usrReq_params: Array<Array<string>> = [];

        usrReq_params.push(["data", ko.toJSON({ idTag })]);

        this.tagXHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.tagXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.tagXHRHdl.onReadyStateFunction = this.sendSimpleRequest;
        this.tagXHRHdl.execute();

    }

    protected insertTagElement(elementToReplace, element, target){

        if(elementToReplace != null && elementToReplace.parentElement != null){
            elementToReplace.parentElement.removeChild(elementToReplace);
        }
        let editor = this.getEditor(target);

        //set cursor position to end of current selection - to insert tag after elements
        if(editor != null){


            let range = null;
            let selectionElement = editor.getSelection().getStartElement();

            if(selectionElement != null && selectionElement.$ && selectionElement.$.nodeName != "BODY"  && selectionElement.getParent() != null){
                range = editor.createRange();
                range.setStartAt( selectionElement, CKEDITOR.POSITION_AFTER_END );
                range.collapse( true );
            }else if(selectionElement == null){
                range = editor.createRange();
                range.moveToElementEditEnd( range.root );
            }
            editor.insertHtml(element, 'html', range);
        }
    }

    protected saveTag(saveData) {

        this.newsletterInteractionEmailEditTemplate.tagPicker.showEditLoading();

        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url = '/api/brand/' + idBrand + "/tag-picker/tags/save/";

        let formReq_params: Array<Array<string>> = [];

        formReq_params.push(["data", ko.toJSON(saveData)] );

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url,formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onSaveTagReturn
        XHRHdl.execute();
    }

    protected onSaveTagReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                let showPickerIfTagNew = false
                if(responseParsed.tag){

                    obj.newsletterInteractionEmailEditTemplate.tagPicker.hideEdit();

                    const {tempTagItemPros, tempTagItemCons} = obj.newsletterInteractionEmailEditTemplate.tagPicker.tagEdit.getTemplateViewModel()

                    let tag = responseParsed.tag;

                    tag.specsValues = responseParsed.specsValues;
                    tag.specDefaults = responseParsed.specDefaults;
                    tag.includeCommunityRating = responseParsed.includeCommunityRating;
                    tag.communityRating = responseParsed.communityRating;
                    tag.hasTagHubPage = responseParsed.hasTagHubPage;

                    if(responseParsed.newTag){
                        showPickerIfTagNew = true
                        obj.newsletterInteractionEmailEditTemplate.tagPicker.setTagAfterAddNew(tag);
                    }else{
                        obj.newsletterInteractionEmailEditTemplate.tagPicker.setTagAfterSave({...tag, pros : tempTagItemPros(), cons : tempTagItemCons() });
                    }
                    obj.newsletterInteractionEmailEditTemplate.tagPicker.updateSelectedTagAfterSave(tag);

                    if (showPickerIfTagNew) {
                        obj.newsletterInteractionEmailEditTemplate.tagPicker.setTagAfterSave({...tag, pros : tempTagItemPros(), cons : tempTagItemCons() });
                    }
                }
            });

            obj.newsletterInteractionEmailEditTemplate.tagPicker.hideEditLoading();

            if(obj.validationTemplate.getTemplateViewModel().isHidden() == 0) {
                obj.newsletterInteractionEmailEditTemplate.addTagPickerValidationClass();
            } else if(obj.validationTemplate.getTemplateViewModel().isHidden() == 1) {
                obj.newsletterInteractionEmailEditTemplate.removeTagPickerValidationClass();
            }
        }
    }

    public getBrandId() {

        return this.getVnAppZone().app.params.idBrand;
    }

    public getTagToEdit() {

        return this.newsletterInteractionEmailEditTemplate.tagPicker.tagView.getTag()
    }

    protected updateTagPickerForm(responseParsed) {

        let selectedTags = this.newsletterInteractionEmailEditTemplate.tagPicker.getSelectedTags();

        if( responseParsed.data ){
            for(let tag of responseParsed.data){
                tag.selected = false;
                let tagSelected = selectedTags.find(i => i.id == tag.id);
                if (tagSelected) {
                    tag.selected = true;
                }
            }
            this.newsletterInteractionEmailEditTemplate.tagPicker.setTagsPagination(responseParsed.totalPage, responseParsed.currentPage);
            this.newsletterInteractionEmailEditTemplate.tagPicker.setTagResults(responseParsed.data);
        }

    }

    protected getTagsByType(idType, keyword = null, limit = null, typeIsNotNull = false){

        // LOADING : starts

        let subViewModel = {filter: {keyword: keyword, limit: limit}, typeIsNotNull: typeIsNotNull};

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        //this.loadingIn(this.newsletterInteractionEmailEditTemplate.builtTemplate);

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/tags/get_by_type_for_review_item/'  + idType;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetTagsRequestReturn;
        this.XHRHdl.execute();
    }

    protected onGetTagsRequestReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {

                //check if user has article write permissions
                let responseParsed = JSON.parse(req.request.response);

                let tags = responseParsed.data;

                if ( obj.XHRHdlCaller == "onAutocompleteAddNewInputChange_filterAutocompleteProduct_template") {

                    if (tags) {

                        obj.newsletterInteractionEmailEditTemplate.filterProducts.getTemplateViewModel().suggestedObj(tags[0]);
                    }

                }
                else if (obj.XHRHdlCaller == "getSuggestions_filterAutocompleteProduct_template")
                {
                    tags.forEach( tag => {
                        if (tag.type != null) {
                            tag.displayNameComplement = tag.name + ' ( ' + tag.type.name + ' ) ';
                        } else {
                            tag.displayNameComplement = tag.name + ' ( * No type * )';
                        }

                        if (tag.details != null){

                            tag.isSelectable = tag.details.isSelectable;
                        }else{

                            tag.isSelectable = false;
                        }

                    })

                    obj.newsletterInteractionEmailEditTemplate.filterProducts.setOptions(tags);
                    obj.newsletterInteractionEmailEditTemplate.filterProducts.setIsLoading(false);

                }

            });
            obj.loadingOut(obj.newsletterInteractionEmailEditTemplate.builtTemplate);
        }
    }

    protected getTagsTypeSuggestion(keyword, limit, restrictOwnedTagTypes = false) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {filter: {keyword: keyword, limit: limit, restrictOwnedTagTypes: restrictOwnedTagTypes}};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/tag/type/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetTagTypesSuggestionReturn;
        this.XHRHdl.execute();
    }

    protected onGetTagTypesSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                let tagTypes = responseParsed.data.tagTypes;
                if (obj.XHRHdlCaller == "onAutocompleteAddNewInputChange_filterAutocompleteProductType_template")
                {
                    obj.newsletterInteractionEmailEditTemplate.filterProductTypes.getTemplateViewModel().suggestedObj(tagTypes[0]);
                }
                else if (obj.XHRHdlCaller == "getSuggestions_filterAutocompleteProductType_template")
                {
                    obj.newsletterInteractionEmailEditTemplate.filterProductTypes.setOptions(tagTypes);
                }
                else if (obj.XHRHdlCaller == "getSuggestions_filterTagType")
                {
                    obj.newsletterInteractionEmailEditTemplate.tagPicker.setTagTypeOptions(tagTypes);
                }
                else if (obj.XHRHdlCaller == "getSuggestions_filterAddNewTagType")
                {
                    obj.newsletterInteractionEmailEditTemplate.tagPicker.setAddNewTagTypeOptions(tagTypes);
                }
                else if (obj.XHRHdlCaller == "getSuggestions_filterEditTagType")
                {
                    obj.newsletterInteractionEmailEditTemplate.tagPicker.setEditTagTypeOptions(tagTypes);
                }


            });
        }
    }

    protected getAffiliatesSuggestion(keyword, limit) {


        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {filter: {keyword: keyword, limit: limit}};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/affiliate/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetAffiliatesSuggestionReturn;
        this.XHRHdl.execute();
    }

    protected onGetAffiliatesSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                if (obj.XHRHdlCaller == "onAutocompleteAddNewInputChange_filterAutocompleteAffiliate_template") {

                    obj.newsletterInteractionEmailEditTemplate.filterAffiliates.getTemplateViewModel().suggestedObj(responseParsed.affiliates[0]);
                }
                else if (obj.XHRHdlCaller == "getSuggestions_filterAutocompleteAffiliate_template") {

                    obj.newsletterInteractionEmailEditTemplate.filterAffiliates.setOptions(responseParsed.affiliates);
                }
                else if (obj.XHRHdlCaller == "getSuggestions_filterAutocompleteTagViewAffiliate_template") {

                    obj.newsletterInteractionEmailEditTemplate.tagPicker.setTagViewAffiliateFilterOptions(responseParsed.affiliates);
                }
                else if (obj.XHRHdlCaller == "getSuggestions_filterAutocompleteTagEditAffiliate_template") {

                    obj.newsletterInteractionEmailEditTemplate.tagPicker.setTagEditAffiliateFilterOptions(responseParsed.affiliates);
                }
            });
        }
    }


    //article insert function
    protected getArticlesSuggestion(keyword, idElement) {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {list: {keyword: keyword}, idElement: idElement};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/article/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetArticlesSuggestionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetArticlesSuggestionsReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if (req.request.status == 200) {
                    if (responseParsed.data.articles) {
                        obj.newsletterInteractionEmailEditTemplate.articleFilter.setOptions(responseParsed.data.articles)
                    }
                }
            }
        }
    }

    protected getArticlePreview(article) {

        this.loadingIn(document.getElementsByClassName('w-article-picker')[0]);

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let idArticle = article.id;
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/article/previewNoSave/"+ idArticle +"/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        this.XHRHdl.onReadyStateFunction = this.onGetArticlePreviewReturn;
        this.XHRHdl.execute();
    }

    protected onGetArticlePreviewReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if (req.request.status == 200) {

                    obj.insertArticlePreviewContent(responseParsed.data);

                }else{

                    obj.validationTemplate.setSingleMessage({
                        field: "error",
                        "label": req.request.status,
                        message: responseParsed.message
                    });
                    window.scrollTo(0, 0);
                }
                obj.loadingOut(document.getElementsByClassName('w-article-picker')[0]);
            }
        }
    }

    protected insertArticlePreviewContent(data){

        let html = '';
        let firstParagraph = '';
        let firstParagraphFound = false;
        if (data) {

            let article = data.article;
            let contentBlocks = data.emakiPreview.contentBlocks;

            contentBlocks.forEach(contentBlock => {

                if(!firstParagraphFound && contentBlock.type == "paragraph"){
                    firstParagraph = contentBlock.text;
                    firstParagraphFound = true;
                }
            });

            let articlePermalink = 'https://' + article.brand.domain + article.permalink;
            if(articlePermalink){
                html += '<h2><a class="disable" href="' + articlePermalink + '">' + article.title + '</a></h2>\n';
            }

            if(article.excerpt){
                html +=  '<p>' + article.excerpt + '</p><br />\n';
            }

            if(article.featuredImage){
                html += '<div class="custom-anchor"> <a class="disable" rel="noreferrer noopener" target="_blank" href="' + articlePermalink + '"><img alt="'+article.featuredImage.altText+'" height="' + article.featuredImage.height+ '" src="' + article.featuredImage.url + '" width="' + article.featuredImage.width + '" /></a></div>\n';
            }

            if(firstParagraph){
                html += '<br /><p>' + firstParagraph + '</p><br />\n';
            }

            if(articlePermalink){
                html += '<span class="affiliate-single"><a class="disable" rel="noreferrer noopener" target="_blank" href="' + articlePermalink + '">Read More &raquo;</a></span>';

            }
        }

        this.newsletterInteractionEmailEditTemplate.setArticleInsertPreviewCode(html);

    }

    protected showInsertArticlePopUp(editor){

        this.newsletterInteractionEmailEditTemplate.setArticlePickerTarget(editor.name)
        this.newsletterInteractionEmailEditTemplate.toggleArticleInsertPopUp(true);
    }

    protected filterSimpleOnChange(idElement){

        switch (idElement) {
            case "filterTagSearch":
                this.newsletterInteractionEmailEditTemplate.tagPicker.resetPagination();
                this.getTagData();
                break;
            case "filterArticle":
                let article = this.newsletterInteractionEmailEditTemplate.articleFilter.getTemplateViewModel().articleObj();
                if (article) {
                    this.validationTemplate.clearMessages(); //clear validation
                    this.newsletterInteractionEmailEditTemplate.setArticleInsertPreviewCode(''); //clear preview code
                    this.getArticlePreview(article);
                }
                break
            default:
                this.getImageData()
                break
        }
    }

    protected insertIntoEditor(data) {

        let editor = this.getEditor(this.newsletterInteractionEmailEditTemplate.getArticlePickerTarget())
        let selectionElement = editor.getSelection().getStartElement()
        let range = editor.createRange();
        range.setStartAt( selectionElement, CKEDITOR.POSITION_AFTER_END );
        range.collapse( true );

        //remove class and then insert
        data = data.replaceAll('class="disable"', '');
        editor.insertHtml(data, range);
    }

    protected onAutocompleteInputClear(idElement) {

        if ( idElement == "filterAutocompleteProductType_template" ){

            this.newsletterInteractionEmailEditTemplate.filterProducts.setOptions([]);

            if ( this.newsletterInteractionEmailEditTemplate.filterProducts.getTemplateViewModel().optionObj() ) {

                this.newsletterInteractionEmailEditTemplate.filterProducts.clearInput();
            }

            this.newsletterInteractionEmailEditTemplate.onChangeSelectTag();

        } else if ( idElement == "filterAutocompleteProduct_template" ) {

            this.newsletterInteractionEmailEditTemplate.onChangeSelectTag();

        }
    }

    protected getEditor(target){

        let editor = null;
        switch (target){
            case "contentText":
                editor = contentEditor;
                break;
            case "signatureText":
                editor = signatureEditor;
                break;
        }

        return editor;

    }

    protected filterSimpleCancel() {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
    }

    private sendSimpleRequest(req, obj) {


        return () => {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);
                if (req.request.status == 200) {

                    obj.newsletterInteractionEmailEditTemplate.handleTagInArticle(obj.XHRHdlCaller);

                } else if (req.request.status == 423) {

                    if (obj.XHRHdlCaller == "tag_picker_edit_cancel") {

                        obj.newsletterInteractionEmailEditTemplate.handleTagInArticle(obj.XHRHdlCaller);
                    } else {

                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                        obj.getVnAppZone().showNotificationToModule();
                    }

                }

                obj.newsletterInteractionEmailEditTemplate.tagPicker.hideViewLoading();
            }
        }

    }

    protected onAutocompleteInputClick(idElement) {

        if ( idElement == "filterAutocompleteProduct_template" )
        {

            let filterTypes = this.newsletterInteractionEmailEditTemplate.filterProductTypes.getTemplateViewModel();

            if (filterTypes.addNewSelected())
            {
                this.newsletterInteractionEmailEditTemplate.filterProducts.setOptions([]);

            }
        }
        if ( idElement == "filterAutocompleteProductType_template" ) {
            //this.newsletterInteractionEmailEditTemplate.onChangeSelectTag(); //May be unnecessary
        }

    }

    protected onAutocompleteAddNewSelected(idElement) {

        if ( idElement == "filterAutocompleteProduct_template" ) {

            this.newsletterInteractionEmailEditTemplate.getTemplateViewModel().addedReviewItemTagSpecifications([]);
            this.newsletterInteractionEmailEditTemplate.onChangeSelectTag();
        }
        else if ( idElement == "filterAutocompleteProductType_template" ) {
            //Clearing product when a new type is selected
            this.newsletterInteractionEmailEditTemplate.getTemplateViewModel().addedReviewItemTagSpecifications([]);
            if ( this.newsletterInteractionEmailEditTemplate.filterProductTypes.getTemplateViewModel().addNewSelected() && ! this.newsletterInteractionEmailEditTemplate.filterProducts.getTemplateViewModel().addNewSelected() ) {

                this.newsletterInteractionEmailEditTemplate.filterProducts.clearEverything();
            }
            this.newsletterInteractionEmailEditTemplate.onChangeSelectTag();
        }
    }

    protected onAutocompleteAddNewInputClick(idElement) { //TODO: May be useless

        if ( idElement == "filterAutocompleteProduct_template" ) {

        }
        else if ( idElement == "filterAutocompleteProductType_template" ) {

        }

    }

    protected onAutocompleteAcceptSuggestion(idElement) {

        if ( idElement == "filterAutocompleteProduct_template" ) {

            let filterProducts = this.newsletterInteractionEmailEditTemplate.filterProducts.getTemplateViewModel();
            // let filterTypes = this.newsletterInteractionEmailEditTemplate.filterProductTypes.getTemplateViewModel();

            if (filterProducts.optionObj().type)
            {
                this.newsletterInteractionEmailEditTemplate.filterProductTypes.getTemplateViewModel().addNewSelected(false);
                this.newsletterInteractionEmailEditTemplate.filterProductTypes.setOption(filterProducts.optionObj().type);
            }


        }
    }

    protected onAutocompleteAddNewInputChange(idElement : string) {

        this.XHRHdlCaller = "onAutocompleteAddNewInputChange_" + idElement;

        if ( idElement == "filterAutocompleteProduct_template" )
        {
            let filterTypes = this.newsletterInteractionEmailEditTemplate.filterProductTypes.getTemplateViewModel();
            let filterProducts = this.newsletterInteractionEmailEditTemplate.filterProducts.getTemplateViewModel();
            let idType;
            if (! filterTypes.addNewSelected() ) {
                idType = filterTypes.optionObj() ? filterTypes.optionObj().id : 0;

                if ( filterTypes.optionObj() )
                {
                    idType = filterTypes.optionObj().id;
                }
                else {
                    idType = 0;
                }
            }
            else {
                idType = 0;
            }
            this.getTagsByType(idType, filterProducts.newOptionName(), 1, true);

        }
        else if ( idElement == "filterAutocompleteProductType_template" ) {

            let filterTypes = this.newsletterInteractionEmailEditTemplate.filterProductTypes.getTemplateViewModel();
            this.newsletterInteractionEmailEditTemplate.filterProductTypes.getTemplateViewModel().suggestedObj(""); //TODO: Investigate why this is needed
            this.getTagsTypeSuggestion(filterTypes.newOptionName(), 1);

        }
        else if  ( idElement == "filterAutocompleteAffiliate_template" ) {
            this.getAffiliatesSuggestion(this.newsletterInteractionEmailEditTemplate.filterAffiliates.getTemplateViewModel().newOptionName(), 1);
        }

    }

    protected getSuggestions(keyword, idSourceElement) {
        this.XHRHdlCaller = "getSuggestions_" + idSourceElement;
        if (idSourceElement == "filterAutocompleteProduct_template") {

            let filterTypes =  this.newsletterInteractionEmailEditTemplate.filterProductTypes.getTemplateViewModel();
            let idType = filterTypes.optionObj() ? filterTypes.optionObj().id : 0;

            if (!filterTypes.addNewSelected()) {

                this.getTagsByType(idType, this.newsletterInteractionEmailEditTemplate.filterProducts.getTemplateViewModel().inputText(), 5, true);
            }
            else {
                this.newsletterInteractionEmailEditTemplate.filterProducts.getTemplateViewModel().optionsLoading(false);
            }
        }
        else if (idSourceElement == "filterAutocompleteProductType_template") {

            let filterTypes =  this.newsletterInteractionEmailEditTemplate.filterProductTypes.getTemplateViewModel();
            this.getTagsTypeSuggestion( filterTypes.inputText(), 5);

        }
        else if (idSourceElement == "filterAutocompleteAffiliate_template") {

            let filterAffiliates =  this.newsletterInteractionEmailEditTemplate.filterAffiliates.getTemplateViewModel();
            this.getAffiliatesSuggestion( filterAffiliates.inputText(), 5);

        }
        //TODO here for  idSource Element use getTagSuggestions (already made)

        else if (idSourceElement == "filterTagType"){

            this.getTagsTypeSuggestion( keyword, 5);
        }
        else if (idSourceElement == "filterAddNewTagType" || idSourceElement == "filterEditTagType"){

            this.getTagsTypeSuggestion( keyword, 5, true);
        }
        else if (idSourceElement == "filterAutocompleteTagViewAffiliate_template" || idSourceElement == "filterAutocompleteTagEditAffiliate_template") {

            this.getAffiliatesSuggestion(keyword, 5);
        }

    }

    protected onAutocompleteOptionChange(idElement) {

        this.clearValidationErrors()

        if (idElement === "filterAutocompleteTagEditAffiliate_template") {

            this.newsletterInteractionEmailEditTemplate.tagPicker.updateTagEditAutomaticPricingOptions();
        }

        else if (idElement === "filterAutocompleteTagViewAffiliate_template") {
            this.newsletterInteractionEmailEditTemplate.tagPicker.updateTagViewAutomaticPricingOptions();
        }

        else if ( idElement == "filterAutocompleteProductType_template" ){

            this.newsletterInteractionEmailEditTemplate.filterProducts.getTemplateViewModel().options([]);
            let filterProducts = this.newsletterInteractionEmailEditTemplate.filterProducts.getTemplateViewModel();
            let product = filterProducts.optionObj();

            if (product) {

                if (product.type) {

                    this.newsletterInteractionEmailEditTemplate.filterProducts.clearSelectedOption();
                }

            }


            this.newsletterInteractionEmailEditTemplate.onChangeSelectTag();
        } else if ( idElement == "filterAutocompleteProduct_template" ){

            let filterTypes = this.newsletterInteractionEmailEditTemplate.filterProductTypes.getTemplateViewModel();
            let filterProducts = this.newsletterInteractionEmailEditTemplate.filterProducts.getTemplateViewModel();

            if (!filterTypes.addNewSelected()) {

                let tag = filterProducts.optionObj();
                if (filterTypes.optionObj() === null) {

                    if ( tag && tag.type ) {

                        filterTypes.optionObj(tag.type);
                        filterTypes.inputText(tag.type.name);
                    }
                }
                else if (tag.type.id === filterTypes.optionObj().id ) { //Added after the anna struggle BEGIN

                    if (tag.type.fields) {
                        if (tag.type.fields.length > filterTypes.optionObj().fields.length) {
                            filterTypes.optionObj(tag.type);
                        }
                    }

                }//Added after the anna struggle END
            }
            this.newsletterInteractionEmailEditTemplate.onChangeSelectTag();
        }
        else if ( idElement == "filterAutocompleteAffiliate_template" ){

            if (this.newsletterInteractionEmailEditTemplate.filterAffiliates.getTemplateViewModel().optionObj()) {

                this.newsletterInteractionEmailEditTemplate.filterAffiliates.getTemplateViewModel().placeholder("Affiliate Partner");
            }
        }
        else if (idElement == "filterTagType") {

            this.newsletterInteractionEmailEditTemplate.tagPicker.onAddTagTypeFilter();
        }
        else if ( idElement == "filterEditTagType" ){

            this.newsletterInteractionEmailEditTemplate.tagPicker.onEditTagTypeFilter();
        }

    }

    public clearValidationErrors(){

        this.validationTemplate.clearMessages();
        this.newsletterInteractionEmailEditTemplate.removeValidationClass();
    }

    public filterDropdownOnChange(idElement){

        if(idElement == 'templateSelector') {}

        this.getImageData();
    }
    public setIsImageOptimized(val) {
        // TODO implement method when you delete an image through imagePickerHelper
    }
}



// WEBPACK FOOTER //
// ./js/modules/newsletter_interaction_email_edit.ts